export const INVOICE_PAGE_SIZE = 20;
export const INVOICE_ACTIVITY_PAGE_SIZE = 20;
export const INVOICE_FILTER_NAMES = ['issuedOn', 'dueOn', 'customerId', 'status'];
export const CUSTOMER_INVOICE_FILTER_NAMES = ['issuedOn', 'dueOn', 'status'];
export const MICRO_APP_UNAVAILABLE = 'MICRO_APP_UNAVAILABLE';
export const INVOICE_CUSTOMER_INVALID = 'INVOICE_CUSTOMER_INVALID';
export const INVOICE_TEMPLATE_VERSION_CONFLICT = 'INVOICE_TEMPLATE_VERSION_CONFLICT';
export const INVOICE_CONTENT_LOCKED = 'INVOICE_CONTENT_LOCKED';
export const INVOICE_CONTENT_CONFLICT = 'INVOICE_CONTENT_CONFLICT';
export const INVOICE_CHANGE_REASON_REQUIRED = 'INVOICE_CHANGE_REASON_REQUIRED';
export const INVOICE_CHANGE_REASON_MAX_LENGTH = 500;
